import React from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import { SKILL_LEVELS } from "./constants"

export default function SkillLevelFilterDropdown({ value = [], onChange }) {
  const { t } = useTranslation()

  const handleSelect = (level) => {
    if (value.includes(level)) {
      onChange(value.filter((l) => l !== level))
    } else {
      onChange([...value, level])
    }
  }

  const handleClear = () => {
    onChange([])
  }

  return (
    <div className={styles.dropdownContent}>
      <Flex gap={8} wrap="wrap" className="mb-s">
        {SKILL_LEVELS.map((level) => (
          <Button key={level} type={value.includes(level) ? "primary" : "default"} shape="round" onClick={() => handleSelect(level)}>
            {level}
          </Button>
        ))}
      </Flex>
      <Button type="link" onClick={handleClear}>
        {t("filterTags.clear")}
      </Button>
    </div>
  )
}

SkillLevelFilterDropdown.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired
}
